<template>
  <div v-if="about">
    <h3 class="mb-5">Moment of Glory</h3>
    <div class="h4 mb-5">
      顯示於AboutUs頁面
    </div>

    <!-- Items -->
    <PageCollapse v-for="(item, i) in about.awards" :key="i">
      <template v-slot:head>
        <h3 class="mr-auto">Item {{ i + 1 }}</h3>
      </template>
      <template v-slot:body>
        <!-- Title -->
        <label class="form-item d-flex py-5">
          <h4 class="w-180px">Title</h4>
          <div class="flex-grow-1 flex-basis-0">
            {{ item.title }}
          </div>
        </label>
        <!-- Order -->
        <label class="form-item d-flex py-5">
          <h4 class="w-180px">Order</h4>
          <div class="flex-grow-1 flex-basis-0">
            {{ item.order }}
          </div>
        </label>
        <!-- Description -->
        <label class="form-item d-flex py-5">
          <h4 class="w-180px">Description</h4>
          <div class="flex-grow-1 flex-basis-0">
            {{ item.content }}
          </div>
        </label>
        <!-- img uploader -->
        <div class="d-flex px-5 pt-5 mb-8">
          <div class="w-180px">
            <h4>Banner</h4>
          </div>
          <div class="d-flex justify-end flex-grow-1">
            <div
              class="w-305px h-187px bg-contain bg-center"
              :style="{
                'background-image': `url(${item.logo})`,
                'background-size': 'contain',
              }"
            ></div>
          </div>
        </div>
      </template>
    </PageCollapse>
  </div>
</template>

<script>
import PageCollapse from '@/components/PageCollapse.vue';

export default {
  props: {
    about: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    PageCollapse,
  },
};
</script>

<style></style>
